import CanShow from "./CanShow";
import AffiliateDonates from "@/features/marketing/affiliate/donates/Index";
import AffiliateUsers from "@/features/marketing/affiliate/users/Index";
import AffiliateLinks from "@/features/marketing/affiliate/links/pages/page";
import AffiliateLinksShow from "@/features/marketing/affiliate/links/pages/show/page";
import WhatsappCampaignIndex from "@/features/marketing/whatsapp-campaign/pages/page";
import WhatsappCampaignForm from "@/features/marketing/whatsapp-campaign/pages/form/page";
import WhatsappCampaignShow from "@/features/marketing/whatsapp-campaign/pages/show/page";

export const marketingRoutes = [
  {
    path: "/affiliateUsers",
    element: (
      <CanShow
        page={<AffiliateUsers />}
        ifHas={["advertisementCoordinators"]}
      />
    ),
  },
  {
    path: "/affiliateLinks",
    element: (
      <CanShow page={<AffiliateLinks />} ifHas={["advertisementLinks"]} />
    ),
  },
  {
    path: "/affiliateLinks/:id",
    element: (
      <CanShow page={<AffiliateLinksShow />} ifHas={["advertisementLinks"]} />
    ),
  },
  {
    path: "/affiliateDonates",
    element: (
      <CanShow page={<AffiliateDonates />} ifHas={["coordinatorDonations"]} />
    ),
  },
  {
    path: "/whatsapp-campaign",
    element: (
      <CanShow page={<WhatsappCampaignIndex />} ifHas={["whatsappCampaign"]} />
    ),
  },
  {
    path: "/whatsapp-campaign/create",
    element: (
      <CanShow page={<WhatsappCampaignForm />} ifHas={["whatsappCampaign"]} />
    ),
  },
  {
    path: "/whatsapp-campaign/:id",
    element: (
      <CanShow page={<WhatsappCampaignShow />} ifHas={["whatsappCampaign"]} />
    ),
  },
];
